<template>
  <div @click.stop="$emit('editDream', dream)" @contextmenu.prevent="openContextMenu">
     <vx-card
            class="dream shadow-md hover:shadow-lg border-solid border-2 border-transparent hover:border-black"
            :class="detailMode ? 'cursor-pointer' : ''"
            title=""
            subtitle=""
        >
<!--             <div class="dream__edit">
                <vs-button color="warning" icon="edit" @click.stop="sidebarActive=true" />
            </div> -->
    <template v-slot:title>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
          <img :src="dreamImage ? dreamImage : defaultImage"
              class="responsive card-img-top rounded-lg"/>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="9">
          <div class="ml-2">

            <p class="text-dark font-bold font-bigger">{{dream.title}}</p>
            <p class="text-dark" v-if="dreamSubtitle">{{dreamSubtitle}}</p>
          </div>

          <!-- <div> -->
              <!-- <div v-if="isAnyDescriptionFilled && !focusMode"> -->
                <!-- <vs-divider position="center" class="mt-5"></vs-divider> -->
                <!-- <DreamDescription class="mt-3" title="Why is this dream important to me?" :text="whyDescription"/> -->
                <!-- <DreamDescription class="mt-3" title="What would I gain by achieving this dream?" :text="gainDescription" /> -->
                <!-- <DreamDescription class="mt-3" title="What are possible risks and obstacles?" :text="riskDescription" /> -->
              <!-- </div> -->
          <!-- </div> -->

        </vs-col>
      </vs-row>
    </template>

    <template v-slot:actions>
      <div @click.stop="" class="flex items-center">
        <feather-icon icon="MoreVerticalIcon" @click="openContextMenu" :class="actionElementCss" svgClasses="h-5 w-5" />
        <!-- </div> -->


        <context-menu id="routines-context-menu" ref="dreamCtxMenu">

          <ContextMenuItem title="edit" icon="EditIcon" @contextMenuClicked="$emit('editDream', dream)"/>

          <ContextMenuItem title="delete" icon="Trash2Icon" @contextMenuClicked="handleDelete" color="text-danger"/>

        </context-menu>
      </div>
     </template>
  </vx-card>
  </div>
 </template>
<script>
import progressColor from '@/helpers/progressColor'
// import {currentPeriod, nextPeriod} from '@/helpers/date'
import DoubleClick from '../Generic/DoubleClick'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine'
// import Sidebar from '../Generic/Sidebar'
import DreamDescription from './DreamDescription'
import EditForm from './EditForm'

export default {
  components: {
    DoubleClick,
    StatisticsCardLine,
    DreamDescription,
    EditForm,
    // Sidebar
  },
  props: {
    dream: {
      type: Object,
      required: true,
    },
    focusMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    detailMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    showGoalStats: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data () {
    return {
      sidebarActive:       false,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },
    }
  },
  computed: {
    progress () {
      return this.dream.progress || 0
    },
    progressColor () {
      return progressColor(this.progress, true)
    },
    // plannedGoalsThisMonthCount () {
    //   return this.$store.getters.dreamPlannedGoalsPeriodCount(this.dream, currentPeriod())
    // },
    // plannedGoalsNextMonthCount () {
    //   return this.$store.getters.dreamPlannedGoalsPeriodCount(this.dream, nextPeriod())
    // },
    // totalGoalsCount () {
    //   return this.$store.getters.dreamTotalGoalsCount(this.dream)
    // },
    // finishedGoalsCount () {
    //   return this.$store.getters.goalsByDreamCount(this.dream, true)
    // },
    whyDescription () { return this.dream.whyDescription },
    gainDescription () { return this.dream.gainDescription },
    riskDescription () { return this.dream.riskDescription },
    dreamImage () { return this.dream.img },
    dreamSubtitle () { return this.dream.subtitle },
    dreamTitle () { return this.dream.title },
    isAnyDescriptionFilled () { return this.whyDescription || this.gainDescription || this.riskDescription },
    defaultImage () {
      // if (this.dream.category) {
      //   return '/images/sample/firstdream.svg'
      //   return `/images/sample/${this.dream.category}.svg`
      // } else {
      return '/images/sample/other.svg'
      // }
    }
  },
  methods: {
    openContextMenu () {
      this.$root.$emit('closeAllContextMenus')

      if (this.$refs.dreamCtxMenu) {
        this.$refs.dreamCtxMenu.open()
      }
    },
    handleDelete () {
      this.$store.dispatch('DELETE_DREAM', { dream: this.dream })
      this.$emit('saved')
    },
  }
}
</script>
<style lang="scss">
@media screen and (min-width: 600px) {
  .dream img {
    height: auto;
    width: 100%;
    object-fit: cover;
    object-position: 50% 50%; /* default value: image is centered*/
  }
}

.dream {
  position: relative;

  .vx-card__header {
    padding: 0.6rem !important
  }

  &:hover &__edit {
    opacity: 1;
  }

  .text-grey {
    font-size: 0.8rem;
  }

  &__edit {
    opacity: 0;
    position: absolute;
    right: 1%;
    top: 1%;
  }
}
</style>
